import { useQuery } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'
import type { CommunityEssentialFolderModel } from '@/models'

export interface GetAllFoldersRequest {
  buildingId?: number
}

export const GET_ALL_FOLDERS_BASE_QUERY_KEY = 'useGetAllFolders'

export const getAllFoldersQueryKey = (data: GetAllFoldersRequest) => [
  GET_ALL_FOLDERS_BASE_QUERY_KEY,
  data,
]

export const getAllFolders = async (data: GetAllFoldersRequest, signal?: AbortSignal) => {
  const response = await authAPI.get<CommunityEssentialFolderModel[]>(
    `/building-essential/${data.buildingId}/folder`,
    { signal },
  )
  return response.data
}

export const useGetAllFolders = (data: GetAllFoldersRequest) => {
  return useQuery({
    enabled: !!data.buildingId,
    queryFn: ({ signal }) => getAllFolders(data, signal),
    queryKey: getAllFoldersQueryKey(data),
  })
}
